<template>
  <div class="home-section">
    <div class="tab-page">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  activated() {},
  methods: {
  
  },
};
</script>
<style scoped lang="scss">
.home-section {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  
}
</style>